import { Menu, type MenuClickTriggerProps, type MenuRootProps, type MenuVariantProps } from "@overmap-ai/blocks"
import { memo, type ReactElement } from "react"

import {
	ProcedureStepCompletionStatusMultiSelectGroup,
	type ProcedureStepCompletionStatusMultiSelectGroupProps,
} from "../MenuMultiSelectGroups/ProcedureStepCompletionStatusMultiSelectGroup"

interface ProcedureStepCompletionStatusMultiSelectProps
	extends
		MenuRootProps,
		ProcedureStepCompletionStatusMultiSelectGroupProps,
		MenuVariantProps,
		Omit<MenuClickTriggerProps, "children" | "ref"> {
	children: ReactElement
}

export const ProcedureStepCompletionStatusMultiSelect = memo((props: ProcedureStepCompletionStatusMultiSelectProps) => {
	const { children, values, statuses, onValuesChange, disabled, variant, size, accentColor, ...rest } = props

	return (
		<Menu.Root {...rest}>
			<Menu.ClickTrigger disabled={disabled}>{children}</Menu.ClickTrigger>
			<Menu.Content variant={variant} size={size} accentColor={accentColor}>
				<Menu.Scroll>
					<ProcedureStepCompletionStatusMultiSelectGroup
						values={values}
						statuses={statuses}
						onValuesChange={onValuesChange}
					/>
				</Menu.Scroll>
			</Menu.Content>
		</Menu.Root>
	)
})
ProcedureStepCompletionStatusMultiSelect.displayName = "ProcedureStepCompletionStatusMultiSelect"
